import checkoutFragment from './fragmentCheckout.gql';

const checkoutRetrieve = ({ country }) => (
	`query ($id: ID!) @inContext(country: ${country}) {
	  node(id: $id) {
	  	id
	  	... on Checkout ${checkoutFragment}
	  }
	}`
);

export default checkoutRetrieve;
